export enum RouteMap {
  CITY = '/city/[slug]/[id]/[[...filter]]',
  ARTIST = '/artist/[slug]/[id]',
  ARTIST_EXPERIENCES = '/artist/[slug]/[id]/experiences',
  LOCATION = '/location/[slug]/[id]',
  LOCATION_EXPERIENCES = '/location/[slug]/[id]/experiences',
  LISTING_PAGE = '/listing/[slug]/[id]/[hash]',
  QUESTIONNAIRE = '/questionnaire/[id]',
  TAG = '/tags/[slug]/[id]',
  ADD_EVENT = '/event/add',
  EVENT_PAGE = '/event/[eventSlug]/[eventIdOrEventTypeSlug]',
  EVENT_INFO_PAGE = '/event/[eventSlug]/[eventIdOrEventTypeSlug]/info',
  EVENT_EXPERIENCES = '/event/[eventSlug]/[eventIdOrEventTypeSlug]/experiences',
  EVENT_TYPE_PAGE = '/event/[eventSlug]/[eventIdOrEventTypeSlug]/[eventId]/[eventTypeId]',
  GROUP = '/events/[id]/[slug]',
  SELL = '/sell/[[...eventIdentifiers]]',
  SELL_EVENT = '/sell/event/[eventId]/[[...eventTypeId]]',
  EVENT = '/sell/[draftId]/event',
  CREATE_EVENT = '/sell/[draftId]/create-event/[eventTitle]',
  RESELL = '/sell/[draftId]/resell',
  RESELL_TICKETS = '/sell/[draftId]/resell/tickets',
  FILES = '/sell/[draftId]/files',
  TICKET_INFO = '/sell/[draftId]/ticket-info',
  LISTING = '/sell/[draftId]/original-price',
  SELLING_PRICE = '/sell/[draftId]/selling-price',
  AVATAR = '/sell/[draftId]/avatar',
  PRIVATE = '/sell/[draftId]/private',
  PRIVATE_VERIFIED = '/sell/[draftId]/private/verified',
  PHONE_DETAILS = '/sell/[draftId]/phone-details',
  PAYOUT_INFORMATION = '/sell/[draftId]/payout-information',
  PAYOUT_CREDIT_CARD = '/sell/[draftId]/payout-credit-card',
  VERIFY_IDENTITY = '/sell/[draftId]/verify-identity',
  SUMMARY = '/sell/[draftId]/summary',
  PUBLISH = '/sell/[draftId]/publish',
  PUBLISHED = '/sell/[draftId]/published',
  CLOSED_LOOP = '/sell/tickets/[ticketProvider]/[identifier]/[[...ticketId]]',
  CART = '/cart',
  PENDING_COUNTRY = '/checkout/country',
  PENDING_EMAIL = '/checkout/email',
  PENDING_PHONE = '/checkout/phone',
  PENDING_PAYMENT = '/checkout/summary',
  PENDING_PAYMENT_METHOD = '/checkout/payment/method',
  PENDING_EMAIL_VERIFICATION = '/checkout/summary',
  CHECKOUT_SUMMARY = '/checkout/summary',
  FAILED_PAYMENT = '/checkout/summary',
  SUCCESSFUL_PAYMENT = '/checkout/done/[hash]',
  PROCESSING_PAYMENT = '/checkout/payment',
  CANCELLED_PAYMENT = '/checkout/summary',
  PARTNERS = '/partners',
  ORGANIZERS_DASHBOARD = '/organizers/dashboard',
  CONTENT = '/content/[slug]',
  HOW_DOES_IT_WORK = '/how-does-it-work',
  CONTACT = '/contact',
  HOME = '/',
  LOGIN = '/login',
  LOGOUT = '/logout',
  LOGO = '/logo',
  SEARCH = '/search/[[...params]]',
  MY_LISTINGS = '/my-listings',
  MY_LISTING = '/my-listings/[id]/[hash]',
  BLOG = '/blog',
  BLOG_TAG = '/blog/[slug]/[tag]',
  BLOG_POST = '/blog/[slug]',
  CONTENTFUL_BLOG_POST = '/blog-post/[slug]',
  CATEGORY = '/[slug]',
  PROFILE = '/account',
  FAVORITE_EVENTS = '/saved-events',
  GIVE_CONSENT = '/give-consent',
  CONVERSATIONS = '/conversations',
  CONVERSATION = '/conversations/[id]',
  PROFILE_VERIFY_IDENTITY = '/account/identity/verify',
  PROFILE_VERIFY_DOCUMENT = '/account/identity/document',
  CHANGE_PAYOUT_INFO = '/account/payout-information',
  REMOVE = '/account/remove',
  MY_TICKETS = '/my-tickets',
  TICKET_ALERTS = '/ticket-alerts',
  TICKET_ALERT = '/ticket-alert/[id]',
  ORGANIZER_SHOP = '/organizer-tickets/products/[shopId]',
  ORGANIZER_PRODUCT = '/organizer-tickets/checkout/[productId]',
  ORGANIZER_ORDER = '/organizer-tickets/order/completed/[orderId]',
  RESERVATION = '/reservation/[id]',
  BROWSE = '/browse/[[...period]]',
  UNSUBSCRIBE = '/unsubscribe/:token',
  UNSUBSCRIBE_FEEDBACK = '/unsubscribe/feedback',
  PARTNER_DASHBOARD = '/partners/dashboard',
  PARTNER_ORGANIZATION = '/partners/dashboard/[eventPartnerId]/[organizerBrandId]/events',
  PARTNER_EVENT_OVERVIEW = '/partners/dashboard/[eventPartnerId]/[organizerBrandId]/event/[eventId]',
  PARTNER_EVENT_EDIT = '/partners/dashboard/[eventPartnerId]/[organizerBrandId]/event/[eventId]/edit',
  PARTNER_EVENT_ADD = '/partners/dashboard/[eventPartnerId]/[organizerBrandId]/event/add',
  PARTNER_EVENT_CREATE = '/partners/dashboard/[eventPartnerId]/[organizerBrandId]/event/create',
  EMAIL_VERIFY = '/email/verify/[hash]/[combinedHash]',
  MAGIC_LINK = '/magic-link/[hash]',
  EXPERIENCES = '/experiences',
  THANK_YOU = '/thank-you-message/[id]',
  TICKET_PROVIDER_SELECT = '/ticket-provider/select',
  TICKET_PROVIDER_DASHBOARD = '/ticket-provider/[providerId]/dashboard',
  TICKET_PROVIDER_IMPLEMENTATION_SETUP = '/ticket-provider/[providerId]/implementation/setup',
  TICKET_PROVIDER_IMPLEMENTATION_TEST = '/ticket-provider/[providerId]/implementation/test',
  TICKET_PROVIDER_DOCUMENTATION = '/ticket-provider/[providerId]/documentation',
  BETA = '/account/beta',
  NOTIFICATIONS = '/account/notifications',
  EMAIL_PREFERENCES = '/account/email-preferences',
  NOTIFICATION = '/account/notifications/[notificationId]',
  ACCOUNT_VERIFY = '/account/verify',
  ACCOUNT_VERIFY_BASIC = '/account/verify/basic',
  ACCOUNT_VERIFY_IDENTITY = '/account/verify/identity',
  ACCOUNT_VERIFY_IDENTITY_STRIPE = '/account/verify/identity/stripe',
  ACCOUNT_VERIFY_DOCUMENT = '/account/verify/document',
  ACCOUNT_FOLLOWING = '/account/following',
  ACCOUNT_PAYOUTS = '/account/payouts',
  ACCOUNT_LANGUAGE = '/account/language',
  ACCOUNT_EMAIL = '/account/email',
  START_CASE = '/start-case/:id/:hash',
  CLOSE_CASE = '/close-case/:ticketId',
  REMOVE_TICKET_ALERT = '/ticket-alert/remove/:id/:hash',
  FEEDBACK_OK = '/feedback/[id]/[hash]/ok',
  FEEDBACK_NEGATIVE = '/feedback/[id]/[hash]',
  ADE = '/ade',
  PRE_REGISTER = '/pre-register/[slug]',
  APPS = '/apps',
  ACCOUNT_PHONE = '/account/phone',
  SHARE = '/share/[eventName]/[shareLinkId]',
  REVIEWS = '/reviews',
  EVENT_NEW_REVIEW = '/reviews/events/[eventId]/new',
  ORGANIZER_PAGE = '/organizer/[slug]/[id]',
  CONCERTS = '/concerts',
  SPORTS = '/sports',
  CLUBS = '/clubs',
  FESTIVALS = '/festivals',
  THEATRE_AND_COMEDY = '/theatre-and-comedy',
  VOUCHERS_AND_DAY_OUT = '/vouchers-and-day-out',
  FOLLOW = '/follow/[entity]/[id]',
  KINGSDAY = '/kingsday',
  REDBULL_CAMPAIGN = '/redbull-campaign',
  CAMPAIGN = '/campaign/[slug]',
  VERIFICATION_FLOW_PHONE = '/verification/phone',
  VERIFICATION_FLOW_AVATAR = '/verification/avatar',
}

export type RouteMapKeys = keyof typeof RouteMap
